import React, { createContext, useContext } from 'react';

interface SidenavContextValue {
  collapsed: boolean;
}

const SidenavContext = createContext<SidenavContextValue | undefined>(undefined);

export function useSidenavContext() {
  const context = useContext(SidenavContext);
  if (context === undefined) {
    throw new Error('useSidenavContext must be used within SidenavContextProvider');
  }

  return context;
}

export const SidenavContextProvider: React.FC<{
  collapsed: boolean;
  children: React.ReactNode;
}> = ({ collapsed, children }) => {
  return <SidenavContext.Provider value={{ collapsed }}>{children}</SidenavContext.Provider>;
};
